import { gql } from 'graphql-request';

export const translate = gql`
  query Translate($input: TranslationInput!) {
    translate(input: $input) {
      translation
    }
  }
`;

export const generateRules = gql`
  query GenerateRules($input: RuleGenInput!) {
    generateRules(input: $input) {
      sentence
      rules
    }
  }
`;

export const generatePinyin = gql`
  query GeneratePinyin($input: PinyinInput!) {
    generatePinyin(input: $input) {
      results {
        chinese
        pinyin
        english
      }
      sound
    }
  }
`;

export const processGrammar = gql`
  query ProcessGrammar($parseString: String!, $parseType: String!) {
    processGrammar(parseString: $parseString, parseType: $parseType)
  }
`;

export const getRuleMappings = gql`
  query GetRuleMappings($rule: String, $perLanguage: Int) {
    getRuleMappings(rule: $rule, perLanguage: $perLanguage) {
      id
      rule
      perLanguage
    }
  }
`;

export const getRuleMappingSentences = gql`
  query GetRuleMappingSentences($rule: String, $sentence: String) {
    getRuleMappingSentences(rule: $rule, sentence: $sentence) {
      id
      rule
      sentence
    }
  }
`;

export const updatePageTranslations = gql`
  mutation UpdatePageTranslations {
    updatePageTranslations
  }
`;

export const createRuleMapping = gql`
  mutation CreateRuleMapping($input: [RuleMappingInput!]!) {
    createRuleMapping(input: $input) {
      id
      rule
      perLanguage
    }
  }
`;

export const createRuleMappingSentence = gql`
  mutation CreateRuleMappingSentence($input: [RuleMappingSentenceInput!]!) {
    createRuleMappingSentence(input: $input) {
      id
      rule
      sentence
    }
  }
`;

export const randomRules = gql`
  query RandomRules($rulesStr: String!, $count: Int) {
    randomRules(rulesStr: $rulesStr, count: $count) {
      id
      rule
      sentenceId
      sentence {
        id
      }
    }
  }
`;

export const translateMutation = gql`
  mutation Translate(
    $text: String!
    $targetLang: String!
    $sourceLang: String!
  ) {
    translate(
      input: { text: $text, source_lang: $sourceLang, target_lang: $targetLang }
    ) {
      translation
    }
  }
`;
